const WHITESPACE_REGEX = /\s+/g;

export const telHref = (phone: string) =>
  `tel:${phone.replace(WHITESPACE_REGEX, "")}`;

export const mapsSearchUrl = (query: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

export const mapsDirectionsUrl = (query: string) =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(query)}`;

export const mapsEmbedUrl = (query: string, lang: string) =>
  `https://maps.google.com/maps?q=${encodeURIComponent(query)}&hl=${lang}&z=14&output=embed`;

export const initials = (name: string) =>
  name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const HEX_SHORT_LENGTH = 3;
const RGB_MAX = 255;
const LIGHT_LUMINANCE_THRESHOLD = 0.6;

// Czy na danym kolorze tła lepiej czytelny jest ciemny tekst (np. żółty awatar)
export const isLightColor = (hex: string) => {
  let value = hex.replace("#", "");
  if (value.length === HEX_SHORT_LENGTH) {
    value = [...value].map((char) => char + char).join("");
  }
  const [r, g, b] = [0, 2, 4].map(
    (start) => Number.parseInt(value.slice(start, start + 2), 16) / RGB_MAX
  );
  // Przybliżona luminancja (ITU-R BT.709)
  return 0.2126 * r + 0.7152 * g + 0.0722 * b > LIGHT_LUMINANCE_THRESHOLD;
};
